// Yalnız birləşdirmə: hər bölmə apps/web/src/api/ altındadır (konflikt nöqtələrini azaltmaq üçün).
export { ApiError } from './api/client';
export type { ProductListParams } from './api/products';
export type { StockListParams } from './api/stock';
import { authApi } from './api/auth';
import { productsApi } from './api/products';
import { customersApi } from './api/customers';
import { importsApi } from './api/imports';
import { stockApi } from './api/stock';
import { purchasesApi } from './api/purchases';
import { shiftsApi } from './api/shifts';
import { salesApi } from './api/sales';
import { invitationsApi } from './api/invitations';
import { membersApi } from './api/members';
import { debtApi } from './api/debt';
import { transfersApi } from './api/transfers';
import { reportsApi } from './api/reports';
import { shipmentsApi } from './api/shipments';
import { intakeApi } from './api/intake';
import { receiptsApi } from './api/receipts';
import { customerImportApi } from './api/customerImport';
import { modulesApi } from './api/modules';
import { aiApi } from './api/ai';
import { financeApi } from './api/finance';
import { vatApi } from './api/vat';
import { accountApi } from './api/account';
import { devicesApi } from './api/devices';
import { settingsApi } from './api/settings';
import { contractsApi } from './api/contracts';
import { posApi } from './api/pos';
import { suppliersApi } from './api/suppliers';
import { countsApi } from './api/counts';
import { notesApi } from './api/notes';

export const api = {
  ...authApi,
  ...productsApi,
  ...customersApi,
  ...importsApi,
  ...stockApi,
  ...purchasesApi,
  ...shiftsApi,
  ...transfersApi,
  ...reportsApi,
  ...shipmentsApi,
  ...intakeApi,
  ...salesApi,
  ...membersApi,
  ...invitationsApi,
  ...debtApi,
  ...receiptsApi,
  ...customerImportApi,
  ...modulesApi,
  ...aiApi,
  ...financeApi,
  ...vatApi,
  ...accountApi,
  ...devicesApi,
  ...settingsApi,
  ...contractsApi,
  ...posApi,
  ...suppliersApi,
  ...countsApi,
  ...notesApi,
};
